<div class="flex justify-center items-center h-[100vh] p-5">
  <div class="not-found">
  </div>
  <div class="flex flex-col justify-center ml-14">
    <h1>Page Not Found</h1>
    <h5>We couldn't find that page! Not even with x-ray vision.</h5>
    <button pButton label="Go Back" type="button" icon="pi pi-arrow-left" class="p-button-secondary p-button-outlined mt-4 self-end" (click)="goBack()"></button>
  </div>
</div>
